import React from 'react';

import Tooltip from 'components/ui/Tooltip';
import { formatDateTime, formatTimeRelative } from 'utils/time';
import Typography from 'components/ui/Typography';
import { TypographyProps } from 'components/ui/Typography/Typography';

interface Props extends TypographyProps {
    time: Date;
}

const TimeTooltip: React.FC<Props> = ({ time, ...rest }) => {
    return (
        <Tooltip text={formatDateTime(time) ?? ''}>
            <Typography {...rest}>{formatTimeRelative(time, true)}</Typography>
        </Tooltip>
    );
};

export default React.memo(TimeTooltip);
